module.exports = __webpack_public_path__ + "img/consulting.96c63543.webp";